var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "container-cards" }, [
        _c(
          "div",
          { staticClass: "cards" },
          [
            _c("app-card-dashboard", {
              attrs: {
                clickable: true,
                title: "Quantidade total de demandas",
                content: _vm.quantitativo.totalDemandas || "0",
                icon: "fal fa-file-chart-line",
                color: "#00537C"
              },
              on: {
                clickCard: function($event) {
                  return _vm.setFiltro({})
                }
              }
            }),
            _c("app-card-dashboard", {
              attrs: {
                clickable: true,
                title: "Demandas em andamento",
                content: _vm.quantitativo.demandasEmAndamento || "0",
                icon: "fal fa-tasks-alt",
                color: "#FDA764"
              },
              on: {
                clickCard: function($event) {
                  return _vm.setFiltro({ estados: [{ id: 2 }] })
                }
              }
            }),
            _c("app-card-dashboard", {
              attrs: {
                clickable: true,
                title: "Demandas a serem feitas",
                content: _vm.quantitativo.demandasAseremFeitas || "0",
                icon: "fal fa-file-chart-pie",
                color: "#3990FA"
              },
              on: {
                clickCard: function($event) {
                  return _vm.setFiltro({ estados: [{ id: 1 }] })
                }
              }
            }),
            _c("app-card-dashboard", {
              attrs: {
                clickable: true,
                title: "Demandas concluídas",
                content: _vm.quantitativo.demandasConcluidas || "0",
                icon: "fal fa-tasks",
                color: "#11B88B"
              },
              on: {
                clickCard: function($event) {
                  return _vm.setFiltro({ estados: [{ id: 3 }] })
                }
              }
            }),
            _c("app-card-dashboard", {
              attrs: {
                clickable: true,
                title: "Demandas em dia",
                content: _vm.quantitativo.demandasEmDia || "0",
                icon: "fal fa-tasks-alt",
                color: "#BF5FCA"
              },
              on: {
                clickCard: function($event) {
                  return _vm.setFiltro({ situacoes: ["EM_DIA"] })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "cards" },
          [
            _c("app-card-dashboard", {
              attrs: {
                clickable: true,
                title: "Demandas atrasadas",
                content: _vm.quantitativo.demandasAtrasadas || "0",
                icon: "fal fa-alarm-exclamation",
                color: "#FF5D67"
              },
              on: {
                clickCard: function($event) {
                  return _vm.setFiltro({ situacoes: ["ATRASADA"] })
                }
              }
            }),
            _c("app-card-dashboard", {
              attrs: {
                clickable: true,
                title: "Demandas à vencer",
                content: _vm.quantitativo.demandasAvencer || "0",
                icon: "fal fa-engine-warning",
                color: "#FFD36B"
              },
              on: {
                clickCard: function($event) {
                  return _vm.setFiltro({ situacoes: ["A_VENCER"] })
                }
              }
            }),
            _c("app-card-dashboard", {
              attrs: {
                title: "Demandas do usuário",
                content: _vm.quantitativo.demandasUsuario || "0",
                icon: "fal fa-id-card",
                color: "#585770"
              }
            }),
            _c("app-card-dashboard", {
              attrs: {
                title: "Quantidade de usuários",
                content: _vm.quantitativo.totalUsuarios || "0",
                icon: "fal fa-users",
                color: "#62AFE3"
              }
            }),
            _c("app-card-dashboard", {
              attrs: {
                title: "Quantidade de painéis",
                content: _vm.quantitativo.totalPaineis || "0",
                icon: "fal fa-project-diagram",
                color: "#00B283"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card", "tab-position": "bottom" },
          on: { "tab-click": _vm.tabClick }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.LABELS.TODAS_DEMANDAS } },
            [
              _vm.isGraficoAtual(_vm.LABELS.TODAS_DEMANDAS)
                ? _c("grafico", {
                    attrs: {
                      idDiv: "todas_demandas",
                      titulo: "Demandas",
                      dados: _vm.dadosDemandas,
                      keyX: "painel",
                      isDemanda: true,
                      keyY: "quantidade",
                      keyText: "quantidade"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.LABELS.DEMANDAS_ATRASADAS } },
            [
              _vm.isGraficoAtual(_vm.LABELS.DEMANDAS_ATRASADAS)
                ? _c("grafico", {
                    attrs: {
                      idDiv: "demandas_atrasadas",
                      titulo: "Demandas",
                      dados: _vm.dadosDemandas,
                      keyX: "painel",
                      keyY: "quantidade",
                      keyText: "quantidade",
                      isDemanda: true
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.LABELS.DEMANDAS_A_SEREM_FEITAS } },
            [
              _vm.isGraficoAtual(_vm.LABELS.DEMANDAS_A_SEREM_FEITAS)
                ? _c("grafico", {
                    attrs: {
                      idDiv: "demandas_a_serem_feitas",
                      titulo: "Demandas",
                      dados: _vm.dadosDemandas,
                      keyX: "painel",
                      keyY: "quantidade",
                      keyText: "quantidade",
                      isDemanda: true
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.LABELS.DEMANDAS_EM_ANDAMENTO } },
            [
              _vm.isGraficoAtual(_vm.LABELS.DEMANDAS_EM_ANDAMENTO)
                ? _c("grafico", {
                    attrs: {
                      idDiv: "demandas_em_andamento",
                      titulo: "Demandas",
                      dados: _vm.dadosDemandas,
                      keyX: "painel",
                      keyY: "quantidade",
                      keyText: "quantidade",
                      isDemanda: true
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.LABELS.DEMANDAS_A_VENCER } },
            [
              _vm.isGraficoAtual(_vm.LABELS.DEMANDAS_A_VENCER)
                ? _c("grafico", {
                    attrs: {
                      idDiv: "demandas_a_vencer",
                      titulo: "Demandas",
                      dados: _vm.dadosDemandas,
                      keyX: "painel",
                      keyY: "quantidade",
                      keyText: "quantidade",
                      isDemanda: true
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "container-tab-grafico-usuario" },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card", "tab-position": "bottom" },
              on: { "tab-click": _vm.onClickTabGraficoUsuario }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.LABELS.PAINEL } },
                [
                  _vm.isGraficoAtualUsuario(_vm.LABELS.PAINEL)
                    ? _c("grafico", {
                        attrs: {
                          idDiv: "usuario_painel",
                          titulo: "Usuários",
                          dados: _vm.dadosGraficoUsuario,
                          keyX: "usuario",
                          keyY: "quantidade",
                          keyText: "quantidade",
                          tituloX: "Usuário",
                          tituloY: "Quantidade de painéis",
                          isDemanda: true
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.LABELS.DEMANDAS } },
                [
                  _vm.isGraficoAtualUsuario(_vm.LABELS.DEMANDAS)
                    ? _c("grafico", {
                        attrs: {
                          idDiv: "usuario_demanda",
                          titulo: "Usuários",
                          dados: _vm.dadosGraficoUsuario,
                          keyX: "usuario",
                          keyY: "quantidade",
                          keyText: "quantidade",
                          tituloX: "Usuário",
                          isDemanda: true
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("listagem-demandas-relatorio", {
        ref: "listagemDemandas",
        attrs: { id: "listagemDemandas" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8973a7c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8973a7c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/Relatorios.vue
// module id = null
// module chunks = 